const SELECT_SIZE_LABEL = 'SELECT SIZE';

function getOptionName(fieldset) {
  const input = fieldset.querySelector('input[data-option-name]');
  return (
    input?.dataset.optionName?.trim() ||
    fieldset.querySelector('legend')?.textContent?.trim() ||
    ''
  );
}

function getSizeFieldset(sidebar) {
  const variantPicker = sidebar.querySelector('variant-picker');
  if (!variantPicker) return null;

  return Array.from(variantPicker.querySelectorAll('.variant-option')).find((fieldset) => {
    const name = getOptionName(fieldset).toLowerCase();
    return name.includes('size') || name.includes('maat');
  }) || null;
}

function setupSmibProduct(root) {
  const sidebar = root.querySelector('.smib-product-sidebar');
  if (!sidebar) return;

  const sizeFieldset = getSizeFieldset(sidebar);
  const addToCart = sidebar.querySelector('.add-to-cart-button');

  if (!sizeFieldset || !addToCart) return;

  sizeFieldset.classList.add('smib-size-fieldset');

  let toggle = sidebar.querySelector('.smib-size-toggle');

  if (!toggle) {
    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'smib-size-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = `
      <span class="smib-size-toggle__label">SIZE</span>
      <span class="smib-size-toggle__value" aria-live="polite"></span>
      <span class="smib-size-toggle__icon" aria-hidden="true">+</span>
    `;

    sizeFieldset.before(toggle);

    toggle.addEventListener('click', () => {
      const open = sizeFieldset.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  addToCart.dataset.smibLabel = SELECT_SIZE_LABEL;

  if (root.dataset.smibSizeConfirmed !== 'true') {
    sidebar.classList.add('smib-needs-size');
  }

  if (!sizeFieldset.dataset.smibChangeBound) {
    sizeFieldset.dataset.smibChangeBound = 'true';

    sizeFieldset.addEventListener('change', (event) => {
      const input = event.target.closest('input[data-option-name]');
      if (!input) return;

      root.dataset.smibSizeConfirmed = 'true';
      sidebar.classList.remove('smib-needs-size');

      const value = toggle.querySelector('.smib-size-toggle__value');
      if (value) value.textContent = input.value;

      window.setTimeout(() => {
        sizeFieldset.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }, 100);
    });
  }

  if (!addToCart.dataset.smibSizeGateBound) {
    addToCart.dataset.smibSizeGateBound = 'true';

    addToCart.addEventListener(
      'click',
      (event) => {
        if (root.dataset.smibSizeConfirmed === 'true') return;

        event.preventDefault();
        event.stopImmediatePropagation();

        sizeFieldset.classList.add('is-open');
        toggle.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
        toggle.focus({ preventScroll: true });
      },
      true
    );
  }
}

function bootSmibProducts() {
  document.querySelectorAll('.product-information--editorial').forEach((root) => {
    setupSmibProduct(root);

    if (root.dataset.smibObserverBound) return;
    root.dataset.smibObserverBound = 'true';

    const observer = new MutationObserver(() => setupSmibProduct(root));
    observer.observe(root, { childList: true, subtree: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSmibProducts, { once: true });
} else {
  bootSmibProducts();
}
